<template>
  <ul v-if="gallery_sets && gallery_sets.length>0" ref="collection_slider_container" id="id_swiper_collection" class="artist-person__slider swiper-container">
    <div class="swiper-wrapper">
      <div class="swiper-slide"
           v-for="gallery_set in gallery_sets"
           :set_id="gallery_set.set_id"
           :class="(gallery_set.set_id===gcollection)?'active':''"
           v-if="gallery_set['counters']['works']>0">

        <div class="artist-person__word">
          <a class="pointer" v-on:click="change(gallery_set.set_id)">{{ gallery_set.name }}</a>
        </div>
      </div>
    </div>
  </ul>
</template>

<script>
  import GalleryCollectionsMix from '../../../components/GalleryCollectionsMix';

  export default {
    name      : 'gallery-collections-sub',
    mixins: [GalleryCollectionsMix],
  }
</script>



// WEBPACK FOOTER //
// src/sub/flat_light/components/GalleryCollectionsSub.vue